export enum ServiceValidationAction {
    Store,
    Update,
}
